const BET_TYPE_MODEL = {
  0: 'underOverModel',
  1: 'inOutModel',
  2: 'ranges',
};

const MARKET_NAMES = {
  0: 'number',
  1: 'rangeModel',
  2: 'ranges',
};

const MODE_TYPE = {
  UNDER_OVER: 0,
  IN_OUT: 1,
  RANGES: 2,
};

const ICON_BY_BET_TYPE = {
  0: {
    0: ({ number }) => <span>&darr; {number}</span>,
    1: ({ number }) => <span>&uarr; {number}</span>,
  },
  1: {
    0: ({ rangeModel }) => (
      <span>
        &rarr;
        {`${rangeModel.from}-${rangeModel.to}`}
        &larr;
      </span>
    ),
    1: ({ rangeModel }) => (
      <span>
        &larr;
        {`${rangeModel.from}-${rangeModel.to}`}
        &rarr;
      </span>
    ),
  },
  2: (numbers) => (
    <span>
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {numbers.reduce(
        (acc, current, index, arr) =>
          `${acc}${current.from}-${current.to}${index + 1 !== arr.length ? ',' : ''}`,
        ''
      )}
    </span>
  ),
};

Object.freeze(BET_TYPE_MODEL);
Object.freeze(ICON_BY_BET_TYPE);
Object.freeze(MARKET_NAMES);
Object.freeze(MODE_TYPE);

export { BET_TYPE_MODEL, ICON_BY_BET_TYPE, MARKET_NAMES, MODE_TYPE };
